export const ENV_VARS = {
    API_URL: import.meta.env.VITE_COMMON_API_URL,
    AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
    IS_DEVELOPMENT_BUILD: !!import.meta.env.DEV,
    IS_PRODUCTION_BUILD: !!import.meta.env.PROD,
    IS_TESTING_MODE: import.meta.env.MODE === 'test',
    SENTRY_URL: import.meta.env.VITE_SENTRY_URL,
};
